export * from './IconRulerStroked';
